import React from 'react';
import { groupBy } from 'ramda';
import { throwQueryError } from '../../lib/apollo/throwQueryError';
import { AccountPage } from '../../pages/AccountPage';
import { Loading } from '../Loading';
import { useSiteCredits } from '../../hooks/useSiteCredits';
import { SiteCredit } from '../../hooks/useSiteCredits/siteCredits.rest';
import { CreditGroup } from './CreditGroup';
import { ZeroCredit } from './ZeroCredit';

const groupByCurrency = groupBy((credit: SiteCredit) => credit.attributes.currency_unit);

export const SiteCredits: React.FC = () => {
  const { data, loading, error } = useSiteCredits();

  if (error) throwQueryError(error);

  if (loading || !data)
    return (
      <AccountPage title="Site Credits">
        <Loading />
      </AccountPage>
    );

  const creditsByCurrency = groupByCurrency(data.credits.data);
  const currencies = Object.keys(creditsByCurrency);

  return (
    <AccountPage title="Site Credits">
      {currencies.length > 0 ? (
        currencies.map(currency => (
          <CreditGroup
            currency={currency}
            credits={creditsByCurrency[currency] ?? []}
            key={currency}
          />
        ))
      ) : (
        <ZeroCredit />
      )}
    </AccountPage>
  );
};
